import type { FeatureFlag } from '@parsleyai/feature-flags'
import { useFeatureFlags } from './FeatureFlagsContext'

/**
 * Whether one feature is on right now. Re-renders when an admin flips it, with no reload.
 *
 * There is no loading state on purpose: the answer is always a usable boolean, falling back to the
 * flag's registry default until the listener lands. Callers gate UI on it directly rather than
 * handling a third case.
 */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  return useFeatureFlags().isEnabled(flag)
}
